module.exports = __webpack_public_path__ + "media/components/assets/images/makeyourdream/image6-c1bcc5f5e7547ea1b9128af87a2dcdd7.png";